import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IconButton from 'material-ui/IconButton'
import NavigationChevronLeft from 'material-ui/svg-icons/navigation/chevron-left'
import NavigationChevronRight from 'material-ui/svg-icons/navigation/chevron-right'
import SlideInTransitionGroup from './SlideIn'

class CalendarToolbar extends Component {
  static propTypes = {
    DateTimeFormat: PropTypes.func.isRequired,
    displayDate: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    nextMonth: PropTypes.bool,
    onMonthChange: PropTypes.func,
    prevMonth: PropTypes.bool
  }

  static defaultProps = {
    nextMonth: true,
    prevMonth: true
  }

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  }

  state = {
    transitionDirection: 'up',
    height: window.innerHeight
  }

  componentWillMount() {
    window.addEventListener('resize', () =>
      this.setState({ height: window.innerHeight })
    )
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.displayDate !== this.props.displayDate) {
      const nextDirection = this.context.muiTheme.isRtl ? 'right' : 'left'
      const prevDirection = this.context.muiTheme.isRtl ? 'left' : 'right'
      const direction =
        nextProps.displayDate > this.props.displayDate
          ? nextDirection
          : prevDirection
      this.setState({
        transitionDirection: direction
      })
    }
  }

  handleClickPrevMonth = () => {
    if (this.props.onMonthChange) {
      this.props.onMonthChange(-1)
    }
  }

  handleClickNextMonth = () => {
    if (this.props.onMonthChange) {
      this.props.onMonthChange(1)
    }
  }

  render() {
    const { height } = this.state
    const styles = {
      root: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#fff',
        height: height * 0.1
      },
      titleDiv: {
        fontSize: height * 0.03,
        fontWeight: '500',
        textAlign: 'center',
        width: '100%'
      },
      titleText: {
        height: 'inherit',
        paddingTop: height * 0.025
      },
      iconStyle: {
        height: height * 0.05,
        width: height * 0.05
      }
    }
    const { DateTimeFormat, locale, displayDate } = this.props

    const dateTimeFormatted = new DateTimeFormat(locale, {
      month: 'long',
      year: 'numeric'
    }).format(displayDate)

    const nextButtonIcon = this.context.muiTheme.isRtl ? (
      <NavigationChevronLeft />
    ) : (
      <NavigationChevronRight />
    )
    const prevButtonIcon = this.context.muiTheme.isRtl ? (
      <NavigationChevronRight />
    ) : (
      <NavigationChevronLeft />
    )

    return (
      <div style={styles.root}>
        <IconButton
          disabled={!this.props.prevMonth}
          onClick={this.handleClickPrevMonth}
          iconStyle={styles.iconStyle}
        >
          {prevButtonIcon}
        </IconButton>
        <div key={dateTimeFormatted} style={styles.titleText}>
          {dateTimeFormatted}
        </div>
        <IconButton
          disabled={!this.props.nextMonth}
          onClick={this.handleClickNextMonth}
          iconStyle={styles.iconStyle}
        >
          {nextButtonIcon}
        </IconButton>
      </div>
    )
  }
}

export default CalendarToolbar



// WEBPACK FOOTER //
// ./src/components/common/calendar/CalendarToolbar.js